import React from 'react'
import clsx from 'clsx'

import './Container.scss'

interface ContainerProps {
  children: React.ReactNode
  className?: string
}

export default function Container({ children, className }: ContainerProps) {
  return <div className={clsx('zin-container', className)}>{children}</div>
}
